import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'
import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { MetaOption } from './meta-option'
import { metaOptionActions } from './meta-option.actions'
import * as fromMetaOptions from './meta-option.reducer'
import { MetaOptionService } from './meta-option.service'

@Injectable()
export class MetaOptionEffects extends ResourceEffects<MetaOption> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public metaOptionService: MetaOptionService
  ) {
    super(
      fromMetaOptions.FEATURE_NAME,
      metaOptionService,
      metaOptionActions,
      actions$
    )
  }
}
